<template>
  <div>
    <div id="maps">
      <maps />
    </div>
    <v-container grid-list-xl>
      <sv-page-title title="Neem contact op"/>
      <v-layout row wrap>
        <v-flex xs12 sm6 class="mb-2">
          <contact-info/>
        </v-flex>
        <v-flex xs12 sm6 class="mb-2">
          <opening-times/>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  
};
</script>

<style lang="scss">
#maps {
  width: 100%;
  height: 200px;
}
</style>
